import type { Asset, CTA } from '../../lib/tenant-api';

export interface CustomFormFieldItem {
  id: string;
  label: string;
  enabled: boolean;
  type: string;
  placeholder: string;
}

export interface SortableFieldProps {
  field: CustomFormFieldItem;
  onToggle: (id: string) => void;
}

export interface SortableSectionProps {
  section: string;
  children: React.ReactNode;
}

/**
 * 'visitor': the Client Admin editor for the website widget (rotation, weights, forms, CTAs).
 * 'expert': the Domain Expert Agents editor. It picks the one homepage the expert app shows and
 * hides the website-only controls; saving never sends the website-only fields.
 */
export type HomepageEditorMode = 'visitor' | 'expert';

export interface HomepageManagementProps {
  assets: Asset[];
  ctas: CTA[];
  mode?: HomepageEditorMode;
}

/** Sections the Domain Expert app never shows (they need visitor-only endpoints). */
export const VISITOR_ONLY_SECTIONS = ['form', 'cta'];

export const DEFAULT_FORM_FIELDS: CustomFormFieldItem[] = [
  { id: 'email', label: 'Email Address', enabled: false, type: 'email', placeholder: 'your.email@example.com' },
  { id: 'phone', label: 'Phone Number', enabled: false, type: 'phone', placeholder: '(555) 123-4567' },
  { id: 'first_name', label: 'First Name', enabled: false, type: 'text', placeholder: 'Your first name' },
  { id: 'last_name', label: 'Last Name', enabled: false, type: 'text', placeholder: 'Your last name' }
];

export const DEFAULT_SECTION_ORDER = ['logo', 'header', 'rating', 'message', 'testimonial', 'gallery', 'form', 'cta'];
